
import React from 'react'
import ReactLoading from 'react-loading'
import moment from 'moment'
import PropTypes from 'prop-types'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import RetractablePanel from 'components/RetractablePanel'
import CategoryModal from './CategoryModal'
import AddActivity from './AddActivity'
// import Button from 'components/Button'

import { CLAIM_CHRONOLOGY } from 'constants'

import './styles.scss'

export default class Chronology extends BaseComponent {

  constructor() {
    super()

    this.state = {
      fetched: false,
      edittingCategory: false,
      chronology: {},
      stages: [],
      categories: []
    }

    this._bind(
      '_getSuggested', '_renderStage', '_onCategoryEdit', '_showCategoryModal',
      '_categorySelected', '_renderCategory', '_renderCategories', '_renderEditCategory', '_cancelCategoryEdit',
      '_showAddActivity'
    )
  }
  componentDidMount() {
    this._getSuggested()
  }

  _getSuggested() {
    request(CLAIM_CHRONOLOGY(this.props.claimId))
      .then((chronology) => {
        var stages = chronology.stages
        var categories = chronology.categories
        this.setState({
          chronology,
          stages,
          categories,
          fetched: true
        })
      })
  }

  _onCategoryEdit(){
    console.log("editting the chronology...")
    this.setState({
      edittingCategory: true
    })
  }

  _cancelCategoryEdit(){
    this.setState({
      edittingCategory: false
    })
  }

  _showCategoryModal(){
    this.context.toggleModal(
      true,
      <CategoryModal claim={this.props.claim}
                _onSuccess={this._categorySelected.bind(this)}
      />
    )
  }

  _categorySelected(){
    console.log("category selected ...")
  }

  _showAddActivity(){
    console.log("will show add activity ...")
    this.context.toggleModal(
      true,
      <AddActivity claimId={this.props.claimId}
                _onSuccess={this._addedActivity.bind(this)}
      />
    )
  }

  _addedActivity(){
    console.log("activity just added ...")
  }

  _renderStage(stage, index) {
    let activities = []
    const duration_string = (stage.duration > 0 || stage.is_closed) ? stage.duration.toString() : 'en curso'

    if (stage.activities) {
        for (const [i, a] of stage.activities.entries()) {
            var ar = index.toString() + '-' + i.toString()
            var date = a.date ? moment(a.date).format('DD/MM/YYYY') : ''
            activities.push(<li key={ar}>{a.name}: <span className="data">{date}</span></li>)
        }    
    }
    activities.push(<li key={'dur' + index}>Duración: <span className="data">{duration_string}</span></li>)
    const pkey = 'p-' + index.toString()
    const ulkey = 'ul-' + index.toString()
    const disc_class = (index === 0 || index === this.state.stages.length - 1) ? 'disc_on' : 'disc_off'
    
    return (stage.activities) ? (
        <li className="StageSection" key={index}>
            <div className={disc_class}></div>
            <div className="StageSection__content">
              <p key={pkey}>{stage.name}</p>
              <ul key={ulkey}>{activities}</ul>
            </div>
        </li>
    ) : null
  }


  _renderEditCategory(){
    return (
      <div>
        <p>Hola</p>
        <button id="CloseButton" className="CloseButton" onClick={this._cancelCategoryEdit}>
            <i className="material-icons">close</i>
          </button>
      </div>
    )
  }

  _renderCategory(){
    return(
      <div id="CategoryInfo" className="CategoryInfo">
        <p>Tipo de siniestro</p>
        <i className="edit-button material-icons" onClick={this._onCategoryEdit}>edit</i>
        <p>Categoria</p>
        <p>Subcategoria</p>
      </div>
    )
  }

  _renderCategories() {
    let category = this.state.categories[this.state.categories.length - 1]
    return(
      <div id="CategoryInfo" className="CategoryInfo">
        <p className="CategoryInfo__Title" key={category.id}>{category.name}</p>
      </div>
    )
  }


  render() {
    return(
      <div id="ClaimChronology" className="ClaimChronology">
        <RetractablePanel
          ref={(panel) => this.panel = panel}
          name="Cronología del siniestro"
          isToggle={true}
        >
          {/*
          { this.state.edittingCategory ? this._renderEditCategory() : this._renderCategory() }

          <Button className="justify-content-center" onClick={this._showAddActivity} buttonType="primary" size="label">
            <i className="material-icons">add</i>
            Crear nueva
          </Button>
          */}
          { this.state.categories.length > 0 && this._renderCategories() }
          {
            !this.state.fetched ? (
              <ReactLoading id="Spin" type={'spin'} color={'#444'}  />
            ) : ( !!this.state.stages.length ? <ul>{this.state.stages.map(this._renderStage)}</ul> : (
                  <p>No se ha registrado actividad</p>
                )
            )
          }
        </RetractablePanel>
      </div>
    )
  }
}


Chronology.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Chronology/index.js